'use client'
import React, { useState } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { capitalize } from 'lodash'
import { sanatiseUrl } from '@/utils/sanatiseUrl'
const Tab = ({ slug }) => {
    const pathName = usePathname()

    const brandPageLink = `/brand/${slug}`
    const productPageLink = `/brand/${slug}/products`
    const isHomepage = pathName == brandPageLink
    const isProductpage = pathName == productPageLink
    return (
        <>
            <div className=' z-20 item-center sticky inset-x-0 to top-14 md:top-24 sm:top-14  mx-auto flex justify-center items-center w-full gap-5 bg-transparent bg-white p-2'>
                <div className=' ml-1 flex w-fit space-x-2  bg-white   rounded-full border border-gray-200 overflow-hidden'>
                    <Link
                        href={brandPageLink}
                        className={` text-sm outline-none focus:ring-0 rounded-full cursor-pointer py-1 px-4 md:px-8 md:text-lg text-black ${isHomepage ? 'bg-black hover:bg-black text-white font-medium ' : ''}`}

                    >
                        About {capitalize(sanatiseUrl(slug))}
                    </Link>
                    <Link
                        href={productPageLink}
                        className={`outline-none focus:ring-0 rounded-full cursor-pointer p-1 text-sm  py-1 px-4 md:px-8 md:text-lg text-black ${isProductpage ? 'font-medium bg-black hover:bg-black text-white  ' : ''}`}
                    >
                        Products
                    </Link>
                </div>
            </div>

        </>

    )
}

export default Tab